import { Navigate, useLocation } from 'react-router-dom';
import { legacyTarget, type LegacyRedirectRule } from './legacy-redirects';

/** Replaces a moved address with its current one (see LEGACY_REDIRECTS). */
export function LegacyRedirect({ rule }: { rule: LegacyRedirectRule }) {
  const location = useLocation();
  return <Navigate to={legacyTarget(rule, location)} replace />;
}
